// src/utils/controlRequest.js
import axios from 'axios'
import {Message, Loading} from 'element-ui'

// 创建axios实例
const service = axios.create({

  baseURL: 'https://control.zjwec.cn/api',
  // baseURL: 'http://127.0.0.1:9998/api',
  timeout: 30000 // 超时时间
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 可在此处添加token等请求头
    // config.headers['Authorization'] = getToken()
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    const res = response.data

    // 如果是文件流，直接返回
    if (response.config.responseType === 'blob') {
      return response
    }

    // 根据业务状态码处理
    if (res.code !== "0") {
      Message.error(res.message || '请求失败')
      return Promise.reject(new Error(res.message || 'Error'))
    }
    return res.data
  },
  error => {
    console.error('请求错误:', error)
    Message.error(error.message || '请求失败')
    return Promise.reject(error)
  }
)

/**
 * GET请求
 * @param {string} url 请求地址
 * @param {object} params 查询参数
 * @param {object} config axios配置
 * @returns {Promise}
 */
export function get(url, params = {}, config = {}) {
  return service.get(url, {params, ...config})
}

/**
 * POST请求
 * @param {string} url 请求地址
 * @param {object} data 请求体数据
 * @param {object} config axios配置
 * @returns {Promise}
 */
export function post(url, data = {}, config = {}) {
  return service.post(url, data, config)
}

/**
 * 导出文件请求
 * @param {string} url 请求地址
 * @param {object} params 查询参数
 * @param {string} defaultFileName 默认文件名
 * @returns {Promise}
 */
export function exportFile(url, params = {}, defaultFileName = 'export.xlsx') {
  const loading = Loading.service({
    lock: true,
    text: '正在生成文件...',
    spinner: 'el-icon-loading',
    background: 'rgba(0, 0, 0, 0.7)'
  })

  return service.get(url, {
    params,
    responseType: 'blob'
  }).then(response => {
    // 创建下载链接
    const blobUrl = window.URL.createObjectURL(new Blob([response.data]))
    const link = document.createElement('a')

    // 从响应头获取文件名
    const contentDisposition = response.headers['content-disposition']
    let fileName = defaultFileName
    if (contentDisposition) {
      const fileNameMatch = contentDisposition.match(/filename="?(.+?)"?(;|$)/)
      if (fileNameMatch && fileNameMatch[1]) {
        fileName = decodeURIComponent(fileNameMatch[1])
      }
    }

    link.href = blobUrl
    link.setAttribute('download', fileName)
    document.body.appendChild(link)
    link.click()

    // 清理
    document.body.removeChild(link)
    window.URL.revokeObjectURL(blobUrl)

    Message.success('导出成功')
  }).catch(error => {
    console.error('导出失败:', error)
    Message.error(error.message || '导出失败')
    throw error
  }).finally(() => {
    loading.close()
  })
}

export default service



// WEBPACK FOOTER //
// ./src/until/controlRequest.js